import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IDocument } from 'app/services/api5-service/api.interface';
import { OperatorFunction, pipe, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpResponseHandler } from './model';

@Injectable({
  providedIn: 'root',
})
export class RefreshHandlerService implements HttpResponseHandler<IDocument> {
  /** Refresh event subject */
  private readonly refreshSubject = new Subject<void>();

  /** Refresh request stream */
  readonly refreshRequest$ = this.refreshSubject.asObservable();

  handle(): OperatorFunction<IDocument, IDocument> {
    return pipe(
      tap(doc => {
        if (doc.ok?.$refreshmenu === 'yes') {
          this.refreshSubject.next();
        }
      }),
    );
  }

  handleEvent(): OperatorFunction<HttpEvent<IDocument>, HttpEvent<IDocument>> {
    return pipe(
      tap(event => {
        if (
          event.type === HttpEventType.Response &&
          (event as HttpResponse<IDocument>).body?.ok?.$refreshmenu === 'yes'
        ) {
          this.refreshSubject.next();
        }
      }),
    );
  }
}
